export default __webpack_public_path__ + "static/media/HDTX_FS Perubahan Kegiatan Usaha_resume 2025.b91b1873.pdf";